import React, { ReactElement, useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../../../shared/ui/ui-kit/elements/Loader';
import { colorsPalette } from '../../../../shared/ui/styles/colors-palette';
import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';
import { UNEXPECTED_ERROR_KEY } from '../../../infrastructure/types/features/auth/auth-types';

interface ContentProps {
  token?: string;
}

let Content = function ({ token }: ContentProps): ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();

  useEffect(() => {
    if (token) {
      authorizationUiModule.tryTemporarySignIn(token as TemporaryAuthToken);
    }
  }, []);

  const errorKey = !token ? UNEXPECTED_ERROR_KEY : authorizationUiModule.temporarySignInErrorKey;

  if (errorKey) {
    return <ErrorMessage>{t(errorKey)}</ErrorMessage>;
  }

  return <Loader centerOfWindow={true} />;
};

const ErrorMessage = styled.div`
  padding: 40px 16px;
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.dustyRed500};
  text-align: center;
`;

Content = observer(Content);

export { Content };
